export default __webpack_public_path__ + "static/media/close-blue.14f0371b.svg";